module.exports = __webpack_public_path__ + "assets/localizar-mapa.57ecf7876ba4b98439549292c619e1aa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/localizar-mapa.png
 ** module id = 493
 ** module chunks = 0
 **/